/**
 * Home-feed card wrapper around @ah/music/mobile's SongPlayer.
 *
 * Data shape is the GraphQL `MusicSong` returned by `recommendedSongs`.
 * The card title slot says "I curated this for you" — copy lives here so the
 * Home renderer doesn't need to know about the music module's voice.
 */

import type { JSX } from 'react';
import { SongPlayer } from '@ah/music/mobile';
import type { MusicSong } from '@ah/music/shared';

export type { MusicSong } from '@ah/music/shared';

/** Back-compat alias — Home.tsx imports `MusicItem` from prior to the
 *  module-backed rewrite. Same shape, just a renamed type. */
export type MusicItem = MusicSong;

/** Back-compat shim — the dummy version exported a static `musicPool`. We
 *  keep an empty array exported so any stale import compiles cleanly; the
 *  Home feed now sources songs from GraphQL via `recommendedSongs`. */
export const musicPool: MusicSong[] = [];

export function musicCardTitle(_song: MusicSong): string {
  return 'I curated this song for you — do you like it?';
}

export function MusicCard({ item }: { item: MusicSong }): JSX.Element {
  return (
    <div className="bg-card rounded-2xl border border-border shadow-sm overflow-hidden">
      <div className="p-5">
        <SongPlayer song={item} variant="card" />
      </div>
    </div>
  );
}
